import { render, staticRenderFns } from "./Buyers.vue?vue&type=template&id=7b85b1ae&scoped=true&"
import script from "./Buyers.vue?vue&type=script&lang=js&"
export * from "./Buyers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b85b1ae",
  null
  
)

export default component.exports